import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { LockBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/lock'),
    loadMethod: MovieClip.animationLoader,
  },
  lantern_01: 'blocks/lock/particle_lantern_01.png',
  lantern_02: 'blocks/lock/particle_lantern_02.png',
  lantern_03: 'blocks/lock/particle_lantern_03.png',
  lantern_rect: 'blocks/lock/particle_lantern_rect.png',
});

export class LockBlockView extends Container {
  private _count = 0;
  private movieclip: MovieClip;

  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    this._count = value;
    if (this._count === 0) {
      this.movieclip.play('lantern_stage2');
    } else {
      this.movieclip.play('lantern_stage1');
    }
  }

  constructor(props: LockBlockProps) {
    super();
    blockPositionView(this, props);
    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
    });
    this.movieclip.play('lantern_stage1');
  }

  public static assets() {
    return Object.values(manifest());
  }
}
